import { FormGroup } from '@angular/forms';

export class AppUtils {
  public static getFormErrors(theForm: FormGroup, formErrors: any): any {
    for (const field in formErrors) {
      if (!formErrors.hasOwnProperty(field)) {
        continue;
      }

      // Clear previous errors
      formErrors[field] = {};

      // Get the control
      const control = theForm.get(field);

      if (control && control.dirty && !control.valid) {
        formErrors[field] = control.errors;
      }
    }

    return formErrors;
  }

  public static getActiveItems(itemList: Array<any>): Array<any> {
    const onlyActiveItems: any[] = [];

    itemList.forEach(item => {
      if (item.active) {
        onlyActiveItems.push(item);
      }
    });

    return onlyActiveItems;
  }

  public static getSortOrder(key: any): any {
    switch (key) {
      case 'ascend':
        return 1;
      case 'descend':
        return -1;
      default:
        return -1;
    }
  }
  public static sortOrderByName(list: any[]): any {
    return list.sort((a, b): any => {
      return a.name.localeCompare(b.name);
    });
  }
}
